// Eskom PARCC — Findings-register XLSX sheet builder (pure).
//
// The Excel counterpart to buildFindingsCsv (owner feedback 2: "make the register
// downloadable to Excel"). Reuses the SAME column model — FINDINGS_CSV_HEADERS +
// findingRowCells — so the CSV and the workbook never drift. Returns a plain
// `string[][]` (header row + one row per finding) that `workbookFromSheet` turns
// into a WorkBook; empty findings yield a header-only sheet. No DOM here.
import type { FindingRead } from '../../lib/db';
import { FINDINGS_CSV_HEADERS, findingRowCells, type TxByRef } from './buildFindingsCsv';

/**
 * Build the findings-register sheet rows (header + one row per finding), joining
 * each finding to its transaction via {@link TxByRef}. Order matches the CSV.
 */
export function buildFindingsSheet(findings: readonly FindingRead[], txByRef: TxByRef): string[][] {
  const header = [...FINDINGS_CSV_HEADERS];
  return [header, ...findings.map((f) => findingRowCells(f, txByRef))];
}
